import { render } from "./Painpoint.vue?vue&type=template&id=1aff0038&scoped=true"
import script from "./Painpoint.vue?vue&type=script&lang=js"
export * from "./Painpoint.vue?vue&type=script&lang=js"

import "./Painpoint.vue?vue&type=style&index=0&id=1aff0038&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aff0038"]])

export default __exports__